import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@gasbuddy/react-components';
import styles from './styles.css';

const { convertTimeTo12HoursFormat } = require('../../../../lib/bputils').default;

const DayOfTheWeek = (props) => {
  const { operationHours } = props;

  let hours = `${convertTimeTo12HoursFormat(operationHours.open)}-${convertTimeTo12HoursFormat(operationHours.close)}`;
  if (operationHours.openAllDay) {
    hours = 'OPEN 24 HOURS';
  } else if (operationHours.closed) {
    hours = 'CLOSED';
  } else if (!operationHours.closed && !operationHours.openAllDay && operationHours.open === '----' && operationHours.close === '----') {
    hours = 'N/A';
  }

  return (
    <div className={styles.stationHoursBoxText}>
      <Text centered bold>{operationHours.day}</Text>
      <Text centered>{hours}</Text>
    </div>
  );
};

DayOfTheWeek.propTypes = {
  operationHours: PropTypes.shape({
    day: PropTypes.string,
    open: PropTypes.string,
    close: PropTypes.string,
    openAllDay: PropTypes.bool,
    closed: PropTypes.bool,
  }).isRequired,
};

export default DayOfTheWeek;
